/**
 * 数据可视化接口汇总
 */

import { ajax } from '../index_zd.js'

/**
 * 设备运行状态分析
 * @name querysbyxztfx
 */
export const querysbyxztfx = params => {
  return ajax.post('jcfxxt/querysbyxztfx', params)
}

/**
 * 设备收益分析
 * @name querysbxyfx
 */
export const querysbxyfx = params => {
  return ajax.post('jxfx/querysbxyfx', params)
}

/**
 * CT部位检查分析接口
 */

/**
 * 部位检查次数
 * @name querybwjccs
 */
export const querybwjccs = params => {
  return ajax.post('ctscreen/querybwjccs', params)
}

/**
 * 部位检查收益
 * @name querybwjcsy
 */
export const querybwjcsy = params => {
  return ajax.post('ctscreen/querybwjcsy', params)
}

/**
 * 部位检查有效时长
 * @name querybwjcyxsc
 */
export const querybwjcyxsc = params => {
  return ajax.post('ctscreen/querybwjcyxsc', params)
}

/**
 * 部位检查品牌排行
 * @name queryxbwjcppph
 */
export const queryxbwjcppph = params => {
  return ajax.post('ctscreen/queryxbwjcppph', params)
}

/**
 * 部位检查统计信息
 * @name queryxbwjctjxx
 */
export const queryxbwjctjxx = params => {
  return ajax.post('ctscreen/queryxbwjctjxx', params)
}

/**
 * 检查部位次数
 * @name queryxbwjcyysypp
 */
export const queryxbwjcyysypp = params => {
  return ajax.post('ctscreen/queryxbwjcyysypp', params)
}

/**
 * 设备运行状态分析接口
 */

/**
 * CT类设备检查部位次数
 * @name queryctlsbjcbwcstop
 */
export const queryctlsbjcbwcstop = params => {
  return ajax.post('sbyxztfx/queryctlsbyxzlltop', params)
}

/**
 * CT类设备有效诊疗率
 * @name queryctlsbyxzlltop
 */
export const queryctlsbyxzlltop = params => {
  return ajax.post('sbyxztfx/queryctlsbyxzlsctop', params)
}

/**
 * MR类设备检查部位次数
 * @name querymrlsbjcbwcstop
 */
export const querymrlsbjcbwcstop = params => {
  return ajax.post('sbyxztfx/querymrlsbjcbwcstop', params)
}

/**
 * MR类设备有效诊疗率
 * @name querymrlsbyxzlltop
 */
export const querymrlsbyxzlltop = params => {
  return ajax.post('sbyxztfx/querymrlsbyxzlltop', params)
}

/**
 * 品牌设备完好率
 * @name queryppsbwhl
 */
export const queryppsbwhl = params => {
  return ajax.post('sbyxztfx/queryppsbwhl', params)
}

/**
 * 设备不良事件发生率
 * @name querysbblsjfsl
 */
export const querysbblsjfsl = params => {
  return ajax.post('sbyxztfx/querysbblsjfsl', params)
}

/**
 * 设备分布
 * @name querysbfb
 */
export const querysbfb = params => {
  return ajax.post('sbyxztfx/querywysgs', params)
}

/**
 * 设备统计
 * @name querysbfbtj
 */
export const querysbfbtj = params => {
  return ajax.post('sbyxztfx/querysbzs', params)
}

/**
 * 设备维修保养次数
 * @name querysbwxbycs
 */
export const querysbwxbycs = params => {
  return ajax.post('sbyxztfx/querysbwxbycs', params)
}

/**
 * 异常状态设备
 * @name queryycztsb
 */
export const queryycztsb = params => {
  return ajax.post('sbyxztfx/queryycztsb', params)
}

/**
 * 设备收益分析接口
 */

/**
 * 设备分类占比
 * @name querysbflzb
 */
export const querysbflzb = params => {
  return ajax.post('sbsyfx/querysbflzb', params)
}

/**
 * 设备总成本和收入
 * @name querysbzcbhsr
 */
export const querysbzcbhsr = params => {
  return ajax.post('sbsyfx/querysbzcbhsr', params)
}

/**
 * 品牌收益排名
 * @name querysbyjsypmtop
 */
export const querysbyjsypmtop = params => {
  return ajax.post('sbsyfx/querysbyjsypmtop', params)
}

/**
 * CT效益排名
 * @name queryctxypm
 */
export const queryctxypm = params => {
  return ajax.post('sbsyfx/queryctxypm', params)
}

/**
 * MR效益排名
 * @name querymrxypm
 */
export const querymrxypm = params => {
  return ajax.post('sbsyfx/querymrxypm', params)
}

/**
 * 设备地图数据
 * @name querysbsyfxdt
 */
export const querysbsyfxdt = params => {
  return ajax.post('sbsyfx/querywysgs', params)
}

/**
 * 设备地图数据-统计
 * @name querysbsyfxdttj
 */
export const querysbsyfxdttj = params => {
  return ajax.post('sbsyfx/querysbsysbzs', params)
}

/**
 * 设备投入产出比
 * @name querysbtrccb
 */
export const querysbtrccb = params => {
  return ajax.post('sbsyfx/querysbtrccb', params)
}

/**
 * 设备月均收益排名
 * @name querysbyjsypm
 */
export const querysbyjsypm = params => {
  return ajax.post('sbsyfx/querysbyjsypmtop', params)
}

/**
 * 投资回收期分析
 * @name querytzhsqfx
 */
export const querytzhsqfx = params => {
  return ajax.post('sbsyfx/querytzhsqfx', params)
}

/**
 * 资产总额
 * @name queryzcze
 */
export const queryzcze = params => {
  return ajax.post('sbsyfx/queryzcze', params)
}

/**
 * 资产总量
 * @name queryzczl
 */
export const queryzczl = params => {
  return ajax.post('sbsyfx/queryzczl', params)
}

/**
 * CT检查部位
 */

/**
 * 部位检查次数
 * @name selectInspectCount
 */
export const selectInspectCount = params => {
  return ajax.post('ctInspect/selectInspectCount', params)
}

/**
 * 部位检查有效时长
 * @name selectInspectEffectiveDate
 */
export const selectInspectEffectiveDate = params => {
  return ajax.post('ctInspect/selectInspectEffectiveDate', params)
}

/**
 * 部位检查收益
 * @name selectInspectProfit
 */
export const selectInspectProfit = params => {
  return ajax.post('ctInspect/selectInspectProfit', params)
}

/**
 * 部位检查统计
 * @name selectInspectType
 */
export const selectInspectType = params => {
  return ajax.post('ctInspect/selectInspectType', params)
}

/**
 * 部位品牌列表
 * @name selectInspectSelectBrand
 */
export const selectInspectSelectBrand = params => {
  return ajax.post('ctInspect/selectInspectSelectBrand', params)
}

/**
 * 部位检查医院使用品牌列表
 * @name selectInspectBrand
 */
export const selectInspectBrand = params => {
  return ajax.post('ctInspect/selectInspectBrand', params)
}

/**
 * CT检查部位
 */

/**
 * 部位检查次数
 * @name selectInspectCountMr
 */
export const selectInspectCountMr = params => {
  return ajax.post('mrInspect/selectInspectCount', params)
}

/**
 * 部位检查有效时长
 * @name selectInspectEffectiveDateMr
 */
export const selectInspectEffectiveDateMr = params => {
  return ajax.post('mrInspect/selectInspectEffectiveDate', params)
}

/**
 * 部位检查收益
 * @name selectInspectProfitMr
 */
export const selectInspectProfitMr = params => {
  return ajax.post('mrInspect/selectInspectProfit', params)
}

/**
 * 部位检查统计
 * @name selectInspectTypeMr
 */
export const selectInspectTypeMr = params => {
  return ajax.post('mrInspect/selectInspectType', params)
}

/**
 * 部位品牌列表
 * @name selectInspectSelectBrandMr
 */
export const selectInspectSelectBrandMr = params => {
  return ajax.post('mrInspect/selectInspectSelectBrand', params)
}

/**
 * 部位检查医院使用品牌列表
 * @name selectInspectBrandMr
 */
export const selectInspectBrandMr = params => {
  return ajax.post('mrInspect/selectInspectBrand', params)
}

/**
 * 设备品目分布列表
 * @name queryItemList
 */
export const queryItemList = params => {
  return ajax.post('equipmentConfig/items', params)
}

/**
 * 医疗机构列表
 * @name queryOrgList
 */
export const queryOrgList = params => {
  return ajax.post('equipmentConfig/orgList', params)
}

/**
 * 合同签署年份列表
 * @name queryYearList
 */
export const queryYearList = params => {
  return ajax.post('equipmentConfig/yearList', params)
}

/**
 * 采购金额区间分布列表
 * @name queryPriceList
 */
export const queryPriceList = params => {
  return ajax.post('equipmentConfig/priceList', params)
}

/**
 * 总设备数
 * @name totalDeviceCount
 */
export const totalDeviceCount = params => {
  return ajax.post('overview/totalDeviceCount', params)
}

/**
 * 设备有效检查时长
 * @name effectiveCount
 */
export const effectiveCount = params => {
  return ajax.post('overview/effectiveCount', params)
}

/**
 * 设备检测次数
 * @name checkCount
 */
export const checkCount = params => {
  return ajax.post('overview/checkCount', params)
}

/**
 * 设备预算金额与合同签订金额偏差分析列表
 * @name queryYsHtMoneyList
 */
export const queryYsHtMoneyList = params => {
  return ajax.post('overview/queryYsHtMoneyList', params)
}

/**
 * 品目列表
 * @name queryItemList
 */
export const queryItemsList = params => {
  return ajax.post('overview/itemsList', params)
}

/**
 * 品牌列表
 * @name queryBrandList
 */
export const queryBrandList = params => {
  return ajax.post('overview/brandList', params)
}

/**
 * 设备清单
 * @name devicePage
 */
export const devicePage = async params => {
  return ajax.post('equipmentConfig/devicePage', params)
}

/**
 * 有效时长TOP5
 * @name effectiveTop5
 */
export const effectiveTop5 = params => {
  return ajax.post('overview/effectiveTop5', params)
}

/**
 * 扫描次数TOP5
 * @name checkTop5
 */
export const checkTop5 = params => {
  return ajax.post('overview/checkTop5', params)
}

/**
 * 设备维护成本
 * @name maintenanceList
 */
export const maintenanceList = params => {
  return ajax.post('overview/maintenanceList', params)
}

/**
 * 设备效益分析
 * @name equipmentUsageList
 */
export const equipmentUsageList = params => {
  return ajax.post('overview/equipmentUsageList', params)
}

/**
 * 医院设备数量及占比
 * @name deviceCountList
 */
export const deviceCountList = async params => {
  return ajax.post('equipmentConfig/deviceCountList', params)
}

/**
 * 医疗机构人员配置职称信息分析
 * @name titleList
 */
export const titleList = async params => {
  return ajax.post('equipmentConfig/titleList', params)
}

/**
 * 医疗机构人员配置学历信息分析
 * @name educationList
 */
export const educationList = async params => {
  return ajax.post('equipmentConfig/educationList', params)
}

/**
 * 设备品目分类数据分析
 * @name deviceItemList
 */
export const deviceItemList = params => {
  return ajax.post('overview/deviceItemList', params)
}